import { render, staticRenderFns } from "./promotionDialog.vue?vue&type=template&id=b3701850&scoped=true&"
import script from "./promotionDialog.vue?vue&type=script&lang=js&"
export * from "./promotionDialog.vue?vue&type=script&lang=js&"
import style0 from "./promotionDialog.vue?vue&type=style&index=0&id=b3701850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3701850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3701850')) {
      api.createRecord('b3701850', component.options)
    } else {
      api.reload('b3701850', component.options)
    }
    module.hot.accept("./promotionDialog.vue?vue&type=template&id=b3701850&scoped=true&", function () {
      api.rerender('b3701850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/components/promotionDialog.vue"
export default component.exports